// Screen definition: Proyectos
// Client-side pagination
import type { ScreenDefinition } from '@/types/screen-definition';
import { PROJECT_STATUS_LABELS, PROJECT_STATUS_COLORS } from '@/types';

export const proyectoScreenDef: ScreenDefinition = {
  id: 'proyectos',
  title: 'Proyectos',
  itemLabel: 'proyectos',

  columns: [
    {
      key: 'nombre',
      header: 'Proyecto',
      type: 'custom', // Name + code subtitle
      locked: true,
    },
    {
      key: 'cliente_nombre',
      header: 'Cliente',
      type: 'custom', // Building2 icon + text
      sortable: false,
    },
    {
      key: 'estado',
      header: 'Estado',
      type: 'badge',
      config: {
        labelMap: PROJECT_STATUS_LABELS,
        colorMap: PROJECT_STATUS_COLORS,
      },
    },
    {
      key: 'fecha_inicio_planeada',
      header: 'Fechas',
      type: 'custom', // Two dates with Calendar icons
    },
    {
      key: 'progreso_porcentaje',
      header: 'Progreso',
      type: 'custom', // Progress bar
    },
    {
      key: 'horas_registradas',
      header: 'Horas',
      type: 'custom', // Clock icon + hours / estimated
    },
  ],

  defaultSort: { field: 'nombre', order: 'asc' },

  pagination: {
    mode: 'client',
    defaultPageSize: 25,
  },

  search: {
    enabled: true,
    placeholder: 'Buscar proyectos...',
  },

  quickFilters: [
    {
      key: 'estado',
      options: Object.entries(PROJECT_STATUS_LABELS).map(([value, label]) => ({
        value,
        label,
      })),
    },
  ],

  filterSections: [
    {
      key: 'fechas',
      title: 'Fechas',
      filters: [
        { key: 'fecha', label: 'Rango de fecha', type: 'date-range' },
      ],
    },
  ],

  rowClick: { type: 'navigate', path: '/proyectos/:id' },

  empty: {
    message: 'No hay proyectos que coincidan con los filtros',
    icon: 'FolderKanban',
  },
};
